/* eslint-disable */
import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import './assets/theme.css';
import { startAutoSync } from '@/offline/sync';

const app = createApp(App);
app.use(router);
app.mount('#app');

// Kick offline queue drain (safe no-op if no queue / offline)
startAutoSync();
